export const EXAMPLE_QUERIES = ['H7', 'H4', 'W5W']

const BULB_CODE =
  /^(h([1-9]|1\d)[a-z]?|h2[17]w|hb\d[a-z]?|hir\d|hs\d|d\d[rs]|(c|hp|hy|p[rswy]?|psx|psy|pwy|r|ry|t|w|wy)\d{1,2}w|p[ry]?2[17]|w21|\dw|ba[uyz]?\d{2}[a-z]|t(5|6|10|15|20)|e10|p13|lw5b|r2|s[12]|88[01]|9\d{3})$/

const fold = text =>
  (text || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()

const words = text =>
  fold(text)
    .split(/[^a-z0-9]+/)
    .filter(word => word.length >= 2)

const chassisCodes = name =>
  (fold(name).match(/\([^)]*\)/g) || [])
    .flatMap(group => group.split(/[^a-z0-9_]+/))
    .map(code => code.replace(/^_+|_+$/g, ''))
    .filter(code => code.length >= 2)

export const vehicleMatchesQuery = (vehicle, query) => {
  const name = vehicle?.name || ''
  const model = name.replace(/\([^)]*\)/g, ' ')
  const modelWords = new Set(words(`${vehicle?.brand?.name || ''} ${model}`))
  const codes = new Set(chassisCodes(name))
  return words(query).some(
    word => modelWords.has(word) || (codes.has(word) && !BULB_CODE.test(word))
  )
}

export const vehiclesForSearch = (vehicles, query, { hasProducts }) => {
  const list = vehicles || []
  if (!hasProducts) return list
  return list.filter(vehicle => vehicleMatchesQuery(vehicle, query))
}

export const PLATE_MIN_LENGTH = 5

export const isPlateCandidate = query =>
  (query || '').replace(/[\s-]/g, '').length >= PLATE_MIN_LENGTH

export const searchEmptyState = ({
  hasProducts,
  vehicles,
  isPlate,
  vehiclePacks = 0,
}) => {
  if (isPlate) return 'plate'
  if (hasProducts) return null
  if (vehicles?.length) return 'vehicles'
  if (vehiclePacks > 0) return 'vehiclePacks'
  return 'empty'
}
